import { UserSwitchOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  useGlobalActions,
  useGlobalContext,
} from '../global-context/GlobalContext';
import { useEffectOnce } from '../hooks/utils/useEffectOnce';

const SwitchUserRole = () => {
  const roles = useGlobalContext(c => c.auth.userRoles);
  const currentUserRole = useGlobalContext(c => c.auth.currentUserRole);
  const menusLoading = useGlobalContext(c => c.auth.menusLoading);
  const navigate = useNavigate();

  const { switchUserRole } = useGlobalActions();

  // Auto-set default role
  useEffectOnce(() => {
    if (!currentUserRole && roles.length > 0) {
      const defaultRole = roles.find(role => role.isDefault) || roles[0];
      switchUserRole(defaultRole.roleId);
    }
  });

  const handleSwitchRole = async (roleId: number) => {
    const firstMenuPath = await switchUserRole(roleId);

    if (!firstMenuPath) {
      return;
    }
    navigate(firstMenuPath);
  };

  // Just provide labels (AntD handles click via `onClick`)
  const items: MenuProps['items'] = roles.map(role => ({
    key: role.roleId.toString(),
    label: (
      <div
        style={{
          backgroundColor:
            role.roleId === currentUserRole?.roleId
              ? 'rgb(39, 87, 71)'
              : 'transparent',
          color: role.roleId === currentUserRole?.roleId ? '#fff' : 'inherit',
          fontWeight:
            role.roleId === currentUserRole?.roleId ? 'bold' : 'normal',
          padding: '6px 12px',
          borderRadius: '4px',
          width: '100%',
        }}
      >
        {role.label}
      </div>
    ),
  }));

  const menuProps: MenuProps = {
    items,
    onClick: ({ key }) => {
      handleSwitchRole(Number(key));
    },
  };

  return (
    <Dropdown menu={menuProps} trigger={['hover']} placement='topRight'>
      <span style={{ display: 'flex', alignItems: 'top' }}>
        <UserSwitchOutlined
          style={{ fontSize: '15px', marginRight: '0.6rem' }}
        />{' '}
        Select Role
      </span>
    </Dropdown>
  );
};

export default SwitchUserRole;
